import React, { useEffect, useState, useRef, useCallback } from "react";
import logo from "../assets/images/logo.png";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faChevronLeft,
  faAngleRight,
  faAngleDown,
  faAngleUp,
  faArrowRightToBracket,
  faCoins,
  faGear,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faSquareLinkedin,
  faSquareInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, Button } from "@mui/material";
import SortableList from "./SortableList";
import Spinner from "react-activity/dist/Spinner";
import starimg from "../assets/images/main/stars-img.png";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import userplaceholder from "../assets/images/userplaceholder.png";
import ProgressBar from "@ramonak/react-progress-bar";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { apiUrl } from "../config/Config";

import { Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import samplewelcomepopupimg from "../assets/images/sample-welcome-popup-img.png";
import googleicon from "../assets/images/google_icon.png";

import { PhoneInput } from "react-international-phone";

import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";

const authRoutes = [
  "/login",
  "/sign-in",
  "/signin",
  "/register",
  "/sign-up",
  "/signup",
  "/verify-email-address",
  "/forgot-password",
  "/forget-password",
  "/reset-password",
  "/recover-password",
];

const Header = () => {
  const { pathname } = useLocation();
  const [sticky, setSticky] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [previewloading, setpreviewloading] = useState(false);
  const [showlowcreditspopup, setshowlowcreditspopup] = useState(false);
  const [showexpiryplanpopup, setshowexpiryplanpopup] = useState(false);

  const savedlayouts = useSelector((store) => store.userReducer.savedlayouts);
  const inkcustomerdata = useSelector(
    (store) => store.userReducer.inkcustomerdata
  );
  console.log("Header inkcustomerdata >>", inkcustomerdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [savedlayoutsarr, setsavedlayoutsarr] = useState([]);
  const savedlayoutsarrRef = useRef([]);
  savedlayoutsarrRef.current = savedlayoutsarr;

  const [showprofiledropdown, setshowprofiledropdown] = useState(false);

  const [showwelcomepopup, setshowwelcomepopup] = useState(false);

  const classes = `mainheader ${sticky} mobhide`;

  const [fullname, setfullname] = useState("");
  const [emailaddress, setemailaddress] = useState("");
  const [phonenumber, setphonenumber] = useState("");
  const [password, setpassword] = useState("");
  const [repassword, setrepassword] = useState("");

  const [fullnameerrormessage, setfullnameerrormessage] = useState("");
  const [emailaddresserrormessage, setemailaddresserrormessage] = useState("");
  const [phonenumbererrormessage, setphonenumbererrormessage] = useState("");
  const [passworderrormessage, setpassworderrormessage] = useState("");
  const [repassworderrormessage, setrepassworderrormessage] = useState("");
  const [mismatchpassworderrormessage, setmismatchpassworderrormessage] =
    useState("");

    const [remainingpercentage, setremainingpercentage] = useState(0);

  const [showloading, setshowloading] = useState(false);

  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isValidPhoneNumber = (phone) => {
    const regex = /^\+[1-9]\d{7,14}$/;
    return regex.test(phone);
  };

  const handlesignupfunc = async () => {
    var isfullnameerror = false;
    var isemailaddresserror = false;
    var isphonenumbererror = false;
    var ispassworderror = false;
    var isrepassworderror = false;
    var ismismatchpassworderror = false;

    if (fullname) {
      isfullnameerror = false;
      setfullnameerrormessage("");
    } else {
      isfullnameerror = true;
      setfullnameerrormessage("Full Name cannot be empty.");
    }

    if (emailaddress && isValidEmail(emailaddress)) {
      isemailaddresserror = false;
      setemailaddresserrormessage("");
    } else {
      isemailaddresserror = true;
      if (emailaddress) {
        setemailaddresserrormessage("Invalid Email Address.");
      } else {
        setemailaddresserrormessage("Email Address cannot be empty.");
      }
    }

    if (phonenumber && isValidPhoneNumber(phonenumber)) {
      isphonenumbererror = false;
      setphonenumbererrormessage("");
    } else {
      isphonenumbererror = true;
      setphonenumbererrormessage("Invalid Mobile Number.");
    }

    if (password) {
      ispassworderror = false;
      setpassworderrormessage("");
    } else {
      ispassworderror = true;
      setpassworderrormessage("Enter Password.");
    }

    if (repassword) {
      isrepassworderror = false;
      setrepassworderrormessage("");
    } else {
      isrepassworderror = true;
      setrepassworderrormessage("Enter Re-Password.");
    }

    if (
      !isfullnameerror &&
      !isemailaddresserror &&
      !isphonenumbererror &&
      !ispassworderror &&
      !isrepassworderror &&
      !ismismatchpassworderror
    ) {
      if (password == repassword) {
        console.log("validation passed!!");
        ismismatchpassworderror = false;
        setmismatchpassworderrormessage("");
      } else {
        ismismatchpassworderror = true;
        setmismatchpassworderrormessage(
          "Password & Re-password does not match!!"
        );
        return;
      }
    } else {
      console.log("validation failed!!");
      // alert("validation failed!!");
      return;
    }
    setshowloading(true);
    var data = {
      fullname: fullname,
      emailaddress: emailaddress,
      mobilenumber: phonenumber,
      password: password,
      via: "form",
    };

    try {
      const res = await axios.post(apiUrl + "userregister", data, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.data.status === "success") {
        setshowloading(false);
        setshowwelcomepopup(false);
        navigate("/verify-email-address", {
          state: {
            semail: emailaddress,
            screen: "signup",
          },
        });
      } else {
        alert(res.data.message || "Registration Failed.");
        setshowloading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
      setshowloading(false);
    }
    setshowloading(false);
  };

  const handlesignupwithgoogle = async(token) => {
    setshowloading(true);
    var data = {
      token: token,
    };

    try {
      const res = await axios.post(apiUrl + "userregisterviagoogle", data, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.data.status === "success") {
        setshowloading(false);
        dispatch({ type: "inkcustomerdata", payload: res.data.data })
        navigate('/user-profile');
      } else {
        alert(res.data.message || "Registration Failed.");
        setshowloading(false);
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
      setshowloading(false);
    }
    setshowloading(false);
  }

  const handleSuccess = (credentialResponse) => {
    // const decoded = jwtDecode(credentialResponse.credential);
    // console.log("User Info:", decoded);
    const token = credentialResponse.credential;
    console.log("Token:", token);
    handlesignupwithgoogle(token);

    // Send this token to your backend (Laravel API)
  };

  const toggleDrawer = (state) => {
    setOpen(state);
  };

  const toggleDrawer1 = (state) => {
    setOpen1(state);
  };

  const getMonthlyExpiryDate = (purchaseDateStr, numberOfDays) => {
    const purchaseDate = new Date(purchaseDateStr);
    const expiryDate = new Date(purchaseDate);
    expiryDate.setDate(expiryDate.getDate() + numberOfDays);

    return expiryDate;
  };

  const isMonthlySubscriptionActive = (purchaseDateStr, numberOfDays) => {
    const expiryDate = getMonthlyExpiryDate(purchaseDateStr, numberOfDays);
    const now = new Date();

    return now <= expiryDate;
  };

  const handlegenerateppt = async () => {
    let availablecredits = 0;
    const slideslength = savedlayoutsarrRef?.current?.length;

    if (inkcustomerdata?.plantype == "fixed") {
      availablecredits =
        parseInt(inkcustomerdata?.credits) -
        parseInt(inkcustomerdata?.credits_used);

      if (availablecredits < slideslength) {
        toggleDrawer1(false);
        setshowlowcreditspopup(true);
        return;
      }
    } else if (inkcustomerdata?.plantype == "both") {
      availablecredits =
        parseInt(inkcustomerdata?.credits) -
        parseInt(inkcustomerdata?.credits_used);

      if (availablecredits >= slideslength) {
        if (
          !isMonthlySubscriptionActive(
            inkcustomerdata?.lastpurchased,
            inkcustomerdata?.daysofplan
          )
        ) {
          toggleDrawer1(false);
          setshowexpiryplanpopup(true);
          return;
        }
      } else {
        toggleDrawer1(false);
        setshowlowcreditspopup(true);
        return;
      }
    } else if (inkcustomerdata?.plantype == "daysvalidity") {
      availablecredits =
        parseInt(inkcustomerdata?.credits) -
        parseInt(inkcustomerdata?.credits_used);

      if (
        !isMonthlySubscriptionActive(
          inkcustomerdata?.lastpurchased,
          inkcustomerdata?.daysofplan
        )
      ) {
        toggleDrawer1(false);
        setshowexpiryplanpopup(true);
        return;
      }
    } else {
      const currentUrl = window.location.href;
      localStorage.setItem("redirecturl", currentUrl);
      toggleDrawer1(false);
      navigate("/subscription-list");
      return;
    }

    if (savedlayoutsarrRef?.current?.length > 0) {
      setpreviewloading(true);
      var prevdata = savedlayoutsarrRef?.current;
      var prevarr = [];
      for (var i = 0; i < prevdata?.length; i++) {
        prevarr.push(prevdata[i]?.ppturl);
      }
      const headers = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      var data = {
        ppt_paths: prevarr,
      };
      let resp = await axios
        .post(
          "https://www.theinkorporated.com/api/consolidate-slides",
          data,
          headers
        )
        .then((res) => {
          var prevdata = res?.data;
          window.open(prevdata?.output_path);

          var outputpath = prevdata?.output_path;
          var data = {
            slides_converted: slideslength,
            credits_used: slideslength,
            remaining:
              inkcustomerdata?.plantype == "daysvalidity"
                ? "Unlimited"
                : availablecredits - slideslength,
            plan: inkcustomerdata?.currentplan,
            outputpath: outputpath,
          };
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + inkcustomerdata?.token,
            },
          };

          axios
            .post(apiUrl + "updatecredits", data, headers)
            .then((res) => {
              if (res.data.status === "success") {
                const updatedData = {
                  ...inkcustomerdata,
                  credits_used:
                    parseInt(inkcustomerdata.credits_used) + slideslength,
                };
                dispatch({ type: "inkcustomerdata", payload: updatedData });
                setsavedlayoutsarr([]);
                dispatch({ type: "savedlayouts", payload: [] });
                toggleDrawer1(false);
              } else {
                if (res.data.message == "invalid user") {
                  dispatch({ type: "inkcustomerdata", payload: {} });
                  navigate("/login");
                } else {
                  toast.error(res.data.message || "Something went wrong.");
                }
              }
            })
            .catch((err) => {
              console.error("API Error:", err);
              alert("Network or Server Error!");
            });
          setpreviewloading(false);
        })
        .catch((err) => {
          alert(err.message);
          setpreviewloading(false);
        });
      setpreviewloading(false);
    } else {
    }
  };

  const handlerespfunc = useCallback((t) => {
    console.log("handlerespfunc t >>", t);
    var newarr = t(savedlayoutsarrRef?.current);
    setsavedlayoutsarr(newarr);
    dispatch({ type: "savedlayouts", payload: newarr });
  }, []);

  const removeLayoutfunc = useCallback((t) => {
    var newarr = savedlayoutsarrRef?.current.filter((item) => item.id !== t);
    setsavedlayoutsarr(newarr);
    dispatch({ type: "savedlayouts", payload: newarr });
  }, []);

  const handleuserlogout = async () => {
    var data = {
      emailaddress: inkcustomerdata?.emailaddress,
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + inkcustomerdata?.token,
      },
    };
    try {
      const res = await axios.post(apiUrl + "user-logout", data, headers);
      if (res.data.status === "success") {
        setshowprofiledropdown(false);
        dispatch({ type: "inkcustomerdata", payload: {} });
        toast.success("Logged Out Successfully!!");
        navigate('/login');
      } else {
        if (res.data.message == "invalid user") {
          dispatch({ type: "inkcustomerdata", payload: {} });
          navigate("/login");
        } else {
          toast.error(res.data.message);
        }
      }
    } catch (err) {
      console.error("API Error:", err);
      alert("Network or Server Error!");
    }
    // navigate('/login')
  };

  // const getRemainingDays = (purchaseDateStr, type = "monthly") => {
  //   if (!purchaseDateStr) return 0;
  
  //   const purchaseDate = new Date(purchaseDateStr);
  //   const expiryDate = new Date(purchaseDate);
  
  //   // Apply plan logic
  //   if (type === "monthly") {
  //     expiryDate.setMonth(expiryDate.getMonth() + 1);
  //   } else if (type === "yearly") {
  //     expiryDate.setFullYear(expiryDate.getFullYear() + 1);
  //   }
  
  //   expiryDate.setDate(expiryDate.getDate() - 1); // inclusive logic
  
  //   const now = new Date();
  
  //   // Difference in ms → convert to days
  //   const diff = expiryDate.getTime() - now.getTime();
  
  //   const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  
  //   return days > 0 ? days : 0;
  // };

  const getRemainingDays = (
    purchaseDateStr,
    numberOfDays
  ) => {
    if (!purchaseDateStr) return 0;
  
    const purchaseDate = new Date(purchaseDateStr);
  
    // expiry = purchase date + number of days
    const expiryDate = new Date(purchaseDate);
    expiryDate.setDate(expiryDate.getDate() + numberOfDays);
  
    const now = new Date();
  
    // Difference in ms → convert to days
    const diff = expiryDate.getTime() - now.getTime();
  
    const days = Math.ceil(
      diff / (1000 * 60 * 60 * 24)
    );
  
    return days > 0 ? days : 0;
  };

  const getYearlyProgress = (purchaseDateStr) => {
    const purchaseDate = new Date(purchaseDateStr);
  
    // expiry = +1 year -1 day
    const expiryDate = new Date(purchaseDate);
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    expiryDate.setDate(expiryDate.getDate() - 1);
  
    const now = new Date();
  
    const totalDays = Math.ceil(
      (expiryDate - purchaseDate) / (1000 * 60 * 60 * 24)
    );
  
    const remainingDays = Math.max(
      Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24)),
      0
    );
  
    const percentage = totalDays > 0
      ? (remainingDays / totalDays) * 100
      : 0;
  
    return {
      totalDays,
      remainingDays,
      percentage
    };
  };

  const getSubscriptionProgress = (
    purchaseDateStr,
    numberOfDays
  ) => {
    const purchaseDate = new Date(purchaseDateStr);
  
    // expiry = purchase date + number of days
    const expiryDate = new Date(purchaseDate);
    expiryDate.setDate(expiryDate.getDate() + numberOfDays);
  
    const now = new Date();
  
    const totalDays = Math.ceil(
      (expiryDate - purchaseDate) / (1000 * 60 * 60 * 24)
    );
  
    const remainingDays = Math.max(
      Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24)),
      0
    );
  
    const usedDays = Math.max(totalDays - remainingDays, 0);
  
    const percentage = totalDays > 0
      ? (remainingDays / totalDays) * 100
      : 0;
  
    const usedPercentage = totalDays > 0
      ? (usedDays / totalDays) * 100
      : 0;
  
    return {
      totalDays,
      usedDays,
      remainingDays,
      percentage, // remaining %
      usedPercentage, // used %
      expiryDate
    };
  };

  useEffect(() => {
    setsavedlayoutsarr(savedlayouts);
    if (savedlayoutsarrRef?.current?.length > 0) {
      if (savedlayoutsarrRef?.current?.length == savedlayouts?.length) {
      } else {
        setOpen1(true);
      }
    } else {
    }
  }, [savedlayouts]);

  useEffect(() => {
    const openSavedLayoutsDrawer = () => {
      setOpen1(true);
    };

    window.addEventListener("openSavedLayoutsDrawer", openSavedLayoutsDrawer);
    return () => {
      window.removeEventListener(
        "openSavedLayoutsDrawer",
        openSavedLayoutsDrawer
      );
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setshowprofiledropdown(false);
  }, [pathname]);

  useEffect(() => {
    // sticky header
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const stickyClass = scrollTop >= 300 ? "is-sticky" : "";
      setSticky(stickyClass);
      // console.log(stickyClass);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const isAuthRoute = authRoutes.some(
      (route) => pathname === route || pathname.startsWith(`${route}/`)
    );

    if (isAuthRoute) {
      setshowwelcomepopup(false);
      return;
    }

    const welcomePopupTimer = setTimeout(() => {
      if (!inkcustomerdata || Object.keys(inkcustomerdata).length === 0) {
        setshowwelcomepopup(true);
      }
    }, 15000);

    return () => clearTimeout(welcomePopupTimer);
  }, [pathname, inkcustomerdata]);

  console.log('header inkcustomerdata >>', inkcustomerdata);

  useEffect(() => {
    if(inkcustomerdata && Object.keys(inkcustomerdata)) {
      if(inkcustomerdata?.plantype == "fixed") {
        var currentcredits = parseInt(inkcustomerdata?.credits);
        var credits_used =  parseInt(inkcustomerdata?.credits_used);
        const remaining = currentcredits - credits_used;
        const percentage = (remaining / currentcredits) * 100;
        setremainingpercentage(percentage);

      } else if(inkcustomerdata?.plantype == "both") {
        var currentcredits = parseInt(inkcustomerdata?.credits);
        var credits_used =  parseInt(inkcustomerdata?.credits_used);
        const remaining = currentcredits - credits_used;
        const percentage = (remaining / currentcredits) * 100;
        setremainingpercentage(percentage);

        // console.log('getRemainingDays >>', getRemainingDays("2026-03-26T18:22:34.997921Z", "monthly"));

      } else if(inkcustomerdata?.plantype == "daysofplan") {
        const { percentage, remainingDays } = getSubscriptionProgress(inkcustomerdata?.lastpurchased);
        setremainingpercentage(percentage);
      } else {

      }
    } else {

    }
  }, [])
  return (
    <>
      {/* <ToastContainer
        position="top-right"
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      /> */}
      <div className={classes}>
        <div className="container">
          <div className="headerrow">
            <div className="logodiv">
              <Link to={"/"}>
                <img src={logo} className="mainlogo" />
              </Link>
            </div>
            <div className="header-navbar">
              <nav className="navbar navbar-expand-lg  custom-nav ">
                <ul class="navbar-nav">
                  <li className={"nav-item"}>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li className={"nav-item servicehover"}>
                    <Link>
                      Services
                      <span>
                        <FontAwesomeIcon
                          icon={faAngleDown}
                          className=""
                          style={{ fontSize: 14, marginLeft: 5 }}
                        />
                      </span>
                    </Link>
                    <div className="servicedropdown">
                      <ul>
                        <li className="designhover">
                          Design{" "}
                          <span>
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              className="anglerighticon"
                            />
                          </span>
                          <div className="subdropdown">
                            <ul>
                              <li>
                                <Link
                                  to={"https://www.theinkorporated.com/slideez-ai/"}
                                >
                                  SlideEZ-AI
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={
                                    "https://www.theinkorporated.com/our-work/"
                                  }
                                >
                                  Our Work
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li>
                          <Link
                            to={
                              "https://www.theinkorporated.com/editing-and-proofreading-services/"
                            }
                          >
                            Editorial
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={
                              "https://www.theinkorporated.com/content-writing-services/"
                            }
                          >
                            Content
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"https://www.theinkorporated.com/insights/"}>
                      Insights
                    </Link>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"/subscription-list"}>
                      Pricing
                    </Link>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"https://www.theinkorporated.com/about-us/"}>
                      About Us
                    </Link>
                  </li>
                  <li className={"nav-item"}>
                    <Link to={"https://www.theinkorporated.com/contact-us/"}>
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="header-iconsdiv">
              <div className="header-iconsdiv1">
                <div
                  className="header-insta-icon"
                  onClick={() => {
                    window.open(
                      "https://www.linkedin.com/company/inkorporated-aranca/?originalSubdomain=in",
                      "_blank"
                    );
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSquareLinkedin}
                    className="headericons"
                  />
                </div>
                {inkcustomerdata && Object.keys(inkcustomerdata)?.length > 0 ? (
                  <div className="header-login-icon">
                    <img
                      src={userplaceholder}
                      className="header-userplaceholder"
                      onClick={() => {
                        setshowprofiledropdown(!showprofiledropdown);
                      }}
                    />
                    <FontAwesomeIcon
                      icon={showprofiledropdown ? faAngleUp : faAngleDown}
                      onClick={() => {
                        setshowprofiledropdown(!showprofiledropdown);
                      }}
                      // onClick={() => {
                      //   setshowprofiledropdown(!showprofiledropdown);
                      // }}
                      className=""
                      style={{
                        fontSize: 14,
                        cursor: "pointer",
                        marginLeft: 5,
                        marginTop: 5,
                      }}
                    />
                    {showprofiledropdown ? (
                      <div className="header-user-dropdown" onClick={() => {}}>
                        <div className="header-dropdown-crossrow">
                          <FontAwesomeIcon
                            icon={faXmark}
                            onClick={() => {
                              setshowprofiledropdown(false);
                            }}
                            className=""
                            style={{
                              color: "rgba(255,255,255,0.7)",
                              fontSize: 18,
                              position: "relative",
                              cursor: "pointer",
                              top: 7,
                              left: 5,
                            }}
                          />
                        </div>
                        <div className="header-dropdown-row">
                          <div className="dropdown-namediv">
                            <img src={userplaceholder} />
                            <div className="dropdown-infodiv">
                              <p className="dropdown-name">
                                {inkcustomerdata?.fullname}
                              </p>
                              <p className="dropdown-name dropdown-email">
                                {inkcustomerdata?.emailaddress}
                              </p>
                            </div>
                          </div>
                        </div>
                        <hr className="header-dropdown-hr-border" />
                        {inkcustomerdata && inkcustomerdata?.currentplan ? (
                          <div className="user-creditsbg">
                            <div className="user-creditsbg-firstrow">
                              <FontAwesomeIcon
                                icon={faCoins}
                                className="userprofilecoins"
                                style={{
                                  marginRight: 15,
                                  cursor: "pointer",
                                }}
                              />
                              <div className="user-creditsbg-firstrow-rightdiv">
                                <p className="user-creditsbg-plantext">
                                  Plan : {inkcustomerdata?.currentplan}
                                </p>
                                <p className="user-creditsbg-pendingtext">
                          {
                          inkcustomerdata?.plantype == "daysvalidity" ?
                            <span>{parseInt(inkcustomerdata?.credits_used)} Credits</span> :
                            <span>{parseInt(inkcustomerdata?.credits) - parseInt(inkcustomerdata?.credits_used)} Credits</span>
                          }
                          </p>
                                <p className="user-creditsbg-plantext">
                                  of {inkcustomerdata?.credits} Credits
                                </p>
                                <p className="user-creditsbg-plantext">
                              {
                                inkcustomerdata?.plantype && inkcustomerdata?.plantype !== "fixed" ?
                                getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) > 0 ?
                                getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) > 1 ?
                                 getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) + " days remaining"
                                 :
                                  getRemainingDays(inkcustomerdata?.lastpurchased, parseInt(inkcustomerdata?.daysofplan)) + " day remaining"


                                :
                                 <span style={{color: '#dc3545'}}>Expired</span> : null
                              }
                            </p>
                              </div>
                            </div>
                            <div className="userprofile-progressbardiv">
                              <ProgressBar
                                completed={remainingpercentage}
                                label=""
                                height="12px"
                                customLabelStyles={{ display: "none" }}
                                bgColor="rgba(80, 67, 154, 1)"
                                baseBgColor="rgba(255,255,255,0.8)"
                              />
                            </div>
                          </div>
                        ) : (
                          <div
                            className=""
                            style={{
                              padding: 15,
                              marginTop: 15,
                              paddingBottom: 5,
                            }}
                          >
                            <div className="userprofile-purchasebuttondiv">
                              <div
                                className="registersubmitbtn"
                                onClick={() => {
                                  navigate("/subscription-list");
                                }}
                              >
                                <p>Purchase Credits</p>
                              </div>
                            </div>
                          </div>
                        )}

                        <hr className="header-dropdown-hr-border" />
                        <div
                          className="dropdown-settings-row"
                          onClick={() => {
                            navigate("/user-profile");
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faGear}
                            className="dropdown-settings-icon"
                            style={{
                              marginRight: 10,
                              fontSize: 18,
                              cursor: "pointer",
                              color: "rgba(255,255,255,0.5)",
                            }}
                          />
                          <p className="dropdown-settings-text">Settings</p>
                        </div>
                        <div
                          className="dropdown-settings-row"
                          onClick={() => {
                            handleuserlogout();
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faArrowRightFromBracket}
                            className="dropdown-settings-icon"
                            style={{
                              marginRight: 10,
                              fontSize: 18,
                              cursor: "pointer",
                              color: "#dc3545",
                            }}
                          />
                          <p
                            className="dropdown-settings-text"
                            style={{ color: "#dc3545" }}
                          >
                            Logout
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <div className="header-login-icon">
                    <FontAwesomeIcon
                      icon={faArrowRightToBracket}
                      onClick={() => {
                        navigate("/login");
                      }}
                      className=""
                      style={{ fontSize: 22, cursor: "pointer" }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Menu */}
      <div className="deskhide">
        <div className="mobilemaindiv">
          <div
            className="mobilemenudiv"
            onClick={() => {
              setOpen(true);
            }}
          >
            <FontAwesomeIcon icon={faBars} className="menubaricon" />
          </div>
          <img src={logo} alt="Logo" className="website-logo-m" />
        </div>
        <div className="navbarheight" />
        <Drawer
          anchor="left"
          open={open}
          onClose={() => {
            toggleDrawer(false);
          }}
        >
          <List sx={{ width: 280 }}>
            <div className="mobilemenusidebarmaindiv">
              <div
                className="mobilemenusidebar-closediv"
                onClick={() => {
                  toggleDrawer(false);
                }}
              >
                <FontAwesomeIcon
                  icon={faXmark}
                  className="menubariconsidebar"
                />
              </div>
              <div className="sidebarmain">
                <nav className="navbar navbar-expand-lg  custom-nav ">
                  <ul class="navbar-nav">
                    <li className={"nav-item"}>
                      <Link to={"https://www.theinkorporated.com/"}>Home</Link>
                    </li>
                    <li to={"/"} className={"nav-item"}>
                      <Link>Services</Link>
                    </li>
                    <li className={"nav-item"}>
                      <Link>Insights</Link>
                    </li>
                    <li className={"nav-item"}>
                      <Link>About Us</Link>
                    </li>
                    <li className={"nav-item"}>
                      <Link>Contact Us</Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </List>
        </Drawer>
      </div>
      {/* Save Sidebar */}
      <div className="right-arrow-div">
        <div
          className="righticonbox"
          onClick={() => {
            setOpen1(true);
          }}
        >
          <FontAwesomeIcon
            icon={faChevronLeft}
            className="leftchevicon"
            style={{ color: "#fff", fontSize: 18 }}
          />
        </div>
      </div>
      <Drawer
        anchor="right"
        open={open1}
        onClose={() => {
          toggleDrawer1(false);
        }}
      >
        <List sx={{ width: 280 }}>
          <div className="savesidebar">
            <div className="sidebar-toprow">
              <div>
                <p className="sidebar-avail-credits">
                  {inkcustomerdata && Object.keys(inkcustomerdata)?.length > 0
                    ? inkcustomerdata?.plantype == "daysvalidity"
                      ? "Unlimited Credits"
                      : (
                        <span>
                          Available Credits :{" "}
                          {parseInt(inkcustomerdata?.credits) -
                            parseInt(inkcustomerdata?.credits_used)}
                        </span>
                      )
                    : null}
                </p>
              </div>
              <div
                className="savesidebar-closediv"
                onClick={() => {
                  toggleDrawer1(false);
                }}
              >
                <FontAwesomeIcon
                  icon={faXmark}
                  className="sidebariconsidebar"
                />
              </div>
            </div>

            {savedlayoutsarrRef.current?.length > 0 ? (
              <div className="sidebarmain">
                <p className="saved-layouttexts">Saved Layouts</p>
                <SortableList
                  listarr={savedlayoutsarrRef.current}
                  handleresp={handlerespfunc}
                  removeLayout={removeLayoutfunc}
                />
                <div
                  className="custom-resetbtn sidebar-generate-btn"
                  style={{ backgroundColor: "#198754", minWidth: 116 }}
                  onClick={() => {
                    if (previewloading) {
                    } else {
                      handlegenerateppt();
                    }
                  }}
                >
                  {previewloading ? (
                    <Spinner color="#fff" size={12} className="previewloader" />
                  ) : (
                    <>
                      <img src={starimg} className="start-img" />
                      <p style={{ color: "#fff" }}>Download</p>
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div className="sidebarmain">
                <p className="saved-layouttexts no-layouts-text">
                  No Layouts Added
                </p>
              </div>
            )}
          </div>
        </List>
      </Drawer>

      {/* Low credits popup */}
      <Modal
        show={showlowcreditspopup}
        onHide={() => setshowlowcreditspopup(false)}
        size="lg"
        className="custom-width-modal custom-welcome-popup custom-lowcredits-popup"
      >
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="custom-welcome-main-rightdiv custom-lowcredits-popup-main">
              <div className="header-dropdown-crossrow">
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={() => {
                    setshowlowcreditspopup(false);
                  }}
                  className=""
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: 20,
                    position: "relative",
                    cursor: "pointer",
                    top: 0,
                    left: 0,
                  }}
                />
              </div>
              <p className="section1title">
                <span className="gradient-head">Insufficient Credits</span>
              </p>
              <p className="lowcredits-popup-description">
                You don’t have enough credits to generate these slides.
                <br />
                Please upgrade your plan or purchase additional credits to
                continue.
              </p>
              <div className="userprofile-purchasebuttondiv">
                <div
                  className="registersubmitbtn"
                  onClick={() => {
                    navigate("/subscription-list");
                  }}
                >
                  <p>Purchase Credits</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Expired Plans popup */}
      <Modal
        show={showexpiryplanpopup}
        onHide={() => setshowexpiryplanpopup(false)}
        size="lg"
        className="custom-width-modal custom-welcome-popup custom-lowcredits-popup"
      >
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="custom-welcome-main-rightdiv custom-lowcredits-popup-main">
              <div className="header-dropdown-crossrow">
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={() => {
                    setshowexpiryplanpopup(false);
                  }}
                  className=""
                  style={{
                    color: "rgba(255,255,255,0.7)",
                    fontSize: 20,
                    position: "relative",
                    cursor: "pointer",
                    top: 0,
                    left: 0,
                  }}
                />
              </div>
              <p className="section1title">
                <span className="gradient-head">Your Plan Has Expired</span>
              </p>
              <p className="lowcredits-popup-description">
                Your subscription has expired. Renew your plan or purchase <br />
                additional credits to continue generating presentations.
              </p>
              <div className="userprofile-purchasebuttondiv">
                <div
                  className="registersubmitbtn"
                  onClick={() => {
                    navigate("/subscription-list");
                  }}
                >
                  <p>Renew Plan</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*Add modal */}
      <Modal
        show={showwelcomepopup}
        onHide={() => setshowwelcomepopup(false)}
        size="lg"
        className="custom-width-modal custom-welcome-popup"
      >
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div className="custom-welcome-main-row">
              <div className="custom-welcome-main-leftdiv">
                <img
                  src={samplewelcomepopupimg}
                  className="samplewelcomepopupimg"
                />
                <div className="custom-welcome-main-leftcontentdiv">
                  <p className="section1title">
                    <span className="gradient-head">
                      Start Creating AI-Powered
                    </span>
                    <br />
                    <span className="gradient-head">Slides in Seconds</span>
                  </p>
                </div>
              </div>
              <div className="custom-welcome-main-rightdiv">
                <div className="header-dropdown-crossrow">
                  <FontAwesomeIcon
                    icon={faXmark}
                    onClick={() => {
                      setshowwelcomepopup(false);
                    }}
                    className=""
                    style={{
                      color: "rgba(255,255,255,0.7)",
                      fontSize: 20,
                      position: "relative",
                      cursor: "pointer",
                      top: 0,
                      left: 0,
                    }}
                  />
                </div>
                <p className="section1title">
                  <span className="gradient-head">Create Your Account</span>
                </p>
                <div className="register-inputdiv">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    value={fullname}
                    onChange={(t) => {
                      setfullname(t.target.value);
                    }}
                    autoComplete="off"
                    className="register-textinput form-control"
                    placeholder="Enter your full name"
                  />
                  {fullnameerrormessage ? (
                    <p className="register-error-message">
                      {fullnameerrormessage}
                    </p>
                  ) : null}
                </div>
                <div className="register-inputdiv">
                  <label>Email Address *</label>
                  <input
                    type="text"
                    value={emailaddress ? emailaddress : ""}
                    onChange={(t) => {
                      setemailaddress(t.target.value);
                    }}
                    autoComplete="off"
                    className="register-textinput form-control"
                    placeholder="Enter your email address"
                  />
                  {emailaddresserrormessage ? (
                    <p className="register-error-message">
                      {emailaddresserrormessage}
                    </p>
                  ) : null}
                </div>
                <div className="register-inputdiv">
                  <label>Mobile Number *</label>
                  <PhoneInput
                    defaultCountry="in"
                    name="mobile"
                    value={phonenumber}
                    onChange={(e) => {
                      // setFormData({ ...formData, mobile: e });
                      setphonenumber(e);
                    }}
                    style={{ marginBottom: 15 }}
                  />
                  {phonenumbererrormessage ? (
                    <p className="register-error-message phonenumbererrormessage">
                      {phonenumbererrormessage}
                    </p>
                  ) : null}
                </div>
                <div className="row register-inputdivrow">
                  <div className="col-md-6">
                    <div className="register-inputdiv">
                      <label>Password *</label>
                      <input
                        type="password"
                        value={password}
                        onChange={(t) => {
                          setpassword(t.target.value);
                        }}
                        className="register-textinput form-control"
                        placeholder="Enter your password"
                      />
                      {passworderrormessage ? (
                        <p className="register-error-message">
                          {passworderrormessage}
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="register-inputdiv">
                      <label>Re-type Password *</label>
                      <input
                        type="password"
                        value={repassword}
                        onChange={(t) => {
                          setrepassword(t.target.value);
                        }}
                        className="register-textinput form-control"
                        placeholder="Re-enter your password"
                      />
                      {repassworderrormessage ? (
                        <p className="register-error-message">
                          {repassworderrormessage}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
                {mismatchpassworderrormessage ? (
                  <p className="register-error-message">
                    {mismatchpassworderrormessage}
                  </p>
                ) : null}
                <div
                  className="registersubmitbtn"
                  onClick={() => {
                    if (showloading) {
                    } else {
                      handlesignupfunc();
                    }
                  }}
                >
                  {showloading ? (
                    <div className="spinnermaindiv">
                      <Spinner
                        color="#fff"
                        size={16}
                        className="spinnerCenter"
                      />
                    </div>
                  ) : (
                    <p>Sign Up</p>
                  )}
                </div>
                <div className="orborderdiv">
                  <div className="orderline1"></div>
                  <div className="ortextdiv">
                    <p>OR</p>
                  </div>
                  <div className="orderline1"></div>
                </div>
                <div className="continuewithgoogleicon">
                  <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={() => console.log("Login Failed")}
                  />
                </div>
                <div className="alreadyhaveaccountdiv">
                  <p className="alreadyhaveaccounttext">
                    Already have an account ?
                  </p>
                  <p
                    className="signintext"
                    onClick={() => {
                      setshowwelcomepopup(false);
                      navigate("/login");
                    }}
                  >
                    Sign In
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
